// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/climb-speed-selection.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/climb-speed-selection/climb-speed-selection.js';

mount([g0]);
